// extracted by mini-css-extract-plugin
export var carrierIcon = "_vq-0";
export var carrierLogo = "_vq-1";
export var detailsSection = "_vq-2";